import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app’s Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQIIie8kDVoDvtIo-zRwwoPPoIQHa_5zE",
  authDomain: "bucket-list-bdac4.firebaseapp.com",
  projectId: "bucket-list-bdac4",
  storageBucket: "bucket-list-bdac4.appspot.com",
  messagingSenderId: "364491431019",
  appId: "1:364491431019:web:ba75a28380e82bec33652e",
  measurementId: "G-PTDL7GXS14",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

export default app;
